// extracted by mini-css-extract-plugin
module.exports = {"hamburger":"HamburgerMenu_hamburger__cjwd9","active":"HamburgerMenu_active__iTj_N"};